// Mapeamento de mensagens de erro do Cognito para mensagens em português
const cognitoErrorMap = {
  'User does not exist.': 'Usuário não encontrado',
  'User does not exist': 'Usuário não encontrado',
  'UserNotFoundException': 'Usuário não encontrado',
  'Incorrect username or password.': 'Email ou senha incorretos',
  'Incorrect username or password': 'Email ou senha incorretos',
  'NotAuthorizedException': 'Email ou senha incorretos',
  'User is not confirmed.': 'Usuário não confirmado',
  'UserNotConfirmedException': 'Usuário não confirmado',
  'Password attempts exceeded': 'Muitas tentativas. Tente novamente mais tarde',
  'Too Many Requests': 'Muitas tentativas. Tente novamente mais tarde',
  'TooManyRequestsException': 'Muitas tentativas. Tente novamente mais tarde',
  'PasswordResetRequiredException': 'Reset de senha necessário',
  'Invalid verification code provided': 'Código de verificação inválido',
  'CodeMismatchException': 'Código de verificação inválido',
  'Invalid code provided': 'Código de verificação inválido',
  'ExpiredCodeException': 'Código expirado',
  'Code has expired': 'Código expirado',
  'LimitExceededException': 'Limite de tentativas excedido',
  'Attempt limit exceeded': 'Limite de tentativas excedido',
  'Network Error': 'Erro de conexão',
  'NetworkError': 'Erro de conexão'
};

/**
 * Traduz mensagens de erro do Cognito para chaves de tradução
 * @param {string} errorMessage - Mensagem de erro original
 * @param {function} t - Função de tradução do i18next
 * @returns {string} - Mensagem traduzida ou mensagem original se não encontrada
 */
export const translateCognitoError = (errorMessage, t) => {
  if (!errorMessage) {
    return 'Erro desconhecido';
  }

  // Procura por correspondência exata primeiro
  const translatedMessage = cognitoErrorMap[errorMessage];
  if (translatedMessage) {
    return translatedMessage;
  }

  // Procura por correspondência parcial
  for (const [errorPattern, message] of Object.entries(cognitoErrorMap)) {
    if (errorMessage.includes(errorPattern) || errorPattern.includes(errorMessage)) {
      return message;
    }
  }

  // Se não encontrou tradução, retorna a mensagem original ou erro genérico
  return errorMessage.includes('Error') ? 'Erro de autenticação' : errorMessage;
};

/**
 * Traduz erros de API genéricos
 * @param {object} error - Objeto de erro do axios
 * @param {function} t - Função de tradução do i18next
 * @returns {string} - Mensagem traduzida
 */
export const translateApiError = (error, t) => {
  if (!error) {
    return 'Erro desconhecido';
  }

  // Se é um erro de rede
  if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
    return 'Erro de conexão';
  }

  // Se tem resposta do servidor
  if (error.response?.data?.message) {
    return translateCognitoError(error.response.data.message, t);
  }

  // Se tem mensagem direta
  if (error.message) {
    return translateCognitoError(error.message, t);
  }

  return 'Erro de autenticação';
};